import _classCallCheck from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  align-items: flex-end;\n  display: flex;\n  justify-content: flex-end;\n  padding: 8px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  max-height: 80vh;\n  overflow-y: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  text-transform: none;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  max-height: 80vh;\n  max-width: 100%;\n  overflow-y: ", ";\n  padding: ", ";\n  width: ", "px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-shadow: ", " 0 14px 45px, ", " 0 10px 18px;\n  font-size: 16px;\n  opacity: ", ";\n  transform: translate(0, ", ");\n  transition: transform ", ", opacity ", ",\n    box-shadow ", ";\n\n  &:focus {\n    box-shadow: ", " 0 14px 55px, ", " 0 10px 28px;\n    outline: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  ", "\n\n  opacity: ", ";\n  transition: opacity ", ";\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { Component, createRef } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import FocusLock from 'react-focus-lock';
import { rgba, position } from 'polished';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { property, color, zIndex } from '@scp/ui-shared/theme/variables';
import { Heading1 } from '@scp/ui-shared/components/typography';
import { Paper } from '@scp/ui-shared/components/Paper';
import { getE2eLabel } from '@scp/ui-shared/components/utils'; // react-transition-group API

var TransitionState;

(function (TransitionState) {
  TransitionState["Entering"] = "entering";
  TransitionState["Entered"] = "entered";
  TransitionState["Exiting"] = "exiting";
  TransitionState["Exited"] = "exited";
})(TransitionState || (TransitionState = {}));

var TIMEOUT = {
  enter: 0,
  exit: property.transitionDuration
};
var E2E_SUFFIX = '-modal';

var getWidth = function getWidth(_ref) {
  var narrow = _ref.narrow,
      wide = _ref.wide;
  if (narrow) return 280;
  if (wide) return 576;
  return 360;
};

var OverlayComponent = withoutProps('div', ['visible']);
var Overlay = styled(OverlayComponent)(_templateObject(), rgba('#000', 0.4), position('fixed', '0'), function (props) {
  return props.visible ? 1 : 0;
}, property.transitionEasing, zIndex.modalOverlay);
var PaperComponent = withoutProps(Paper, ['visible']);
var StyledPaper = styled(PaperComponent)(_templateObject2(), rgba('#000', 0.25), rgba('#000', 0.22), function (props) {
  return props.visible ? 1 : 0;
}, function (props) {
  return props.visible ? '0' : '-64px';
}, property.transition, property.transition, property.transition, rgba('#000', 0.35), rgba('#000', 0.32));
var ModalInner = styled.div(_templateObject3(), function (props) {
  return props.scrollable ? 'auto' : 'hidden';
}, function (props) {
  return props.noPadding ? '0' : '24px';
}, getWidth);
var Title = styled(Heading1).attrs({
  as: 'h3'
})(_templateObject4());
var ChildrenWrapper = styled.div(_templateObject5(), color.label, function (props) {
  return props.scrollable ? 'visible' : 'hidden';
});
var Actions = styled.footer(_templateObject6());
/**
 * Stop propagating parent-triggered events
 *
 * @param {Event} e
 */

var preventBubbling = function preventBubbling(e) {
  return e.stopPropagation();
};
/**
 * An universal Modal component.
 * Lightweight alterantive to Material UI's Dialog: http://www.material-ui.com/#/components/dialog
 *
 * @example ./docs/Modal.md
 */


export var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.apply(this, arguments); // Make sure that 'modal-root' exists on the public.html!

    _this.modalRoot = document.getElementById('modal-root');
    _this.modal = createRef();
    _this.transitionRef = createRef(); // Accessibility: close modal with esc key

    _this.watchEscKey = function (e) {
      var _this$props = _this.props,
          open = _this$props.open,
          onRequestClose = _this$props.onRequestClose;

      if (open && (e.key === 'Escape' || e.key === 'Esc')) {
        !!onRequestClose && onRequestClose();
      }
    };

    _this.renderModalByTransition = function (transitionState) {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          title = _this$props2.title,
          actions = _this$props2.actions,
          onRequestClose = _this$props2.onRequestClose,
          narrow = _this$props2.narrow,
          noPadding = _this$props2.noPadding,
          noPaperPadding = _this$props2.noPaperPadding,
          noPaperBorder = _this$props2.noPaperBorder,
          withShadow = _this$props2.withShadow,
          className = _this$props2.className,
          onKeyDown = _this$props2.onKeyDown,
          scrollable = _this$props2.scrollable,
          wide = _this$props2.wide,
          dataE2e = _this$props2.dataE2e;
      return React.createElement(Overlay, {
        onClick: onRequestClose,
        visible: transitionState === TransitionState.Entered
      }, React.createElement(FocusLock, {
        returnFocus: true
      }, React.createElement(StyledPaper, {
        role: "dialog",
        ref: _this.modal,
        onClick: preventBubbling,
        onKeyDown: onKeyDown,
        visible: transitionState === TransitionState.Entered,
        tabIndex: 0,
        padding: noPaperPadding ? 0 : undefined,
        noBorder: noPaperBorder,
        "aria-modal": true,
        withShadow: withShadow,
        "data-e2e": getE2eLabel(title, E2E_SUFFIX, dataE2e)
      }, React.createElement(ModalInner, {
        className: className,
        narrow: narrow,
        wide: wide,
        noPadding: noPadding,
        scrollable: scrollable
      }, typeof title === 'string' ? React.createElement(Title, null, title) : title, React.createElement(ChildrenWrapper, {
        scrollable: scrollable
      }, children)), !!actions && React.createElement(Actions, null, actions))));
    };

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.watchEscKey);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.watchEscKey);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.modalRoot) return null;
      return createPortal(React.createElement(Transition, {
        in: this.props.open,
        timeout: TIMEOUT,
        nodeRef: this.transitionRef,
        unmountOnExit: true,
        mountOnEnter: true
      }, this.renderModalByTransition), this.modalRoot);
    }
  }]);

  return Modal;
}(Component);
Modal.defaultProps = {
  title: null,
  narrow: false,
  wide: false,
  noPadding: false,
  noPaperPadding: false,
  noPaperBorder: false,
  withShadow: false,
  children: null,
  className: '',
  onRequestClose: function onRequestClose() {
    return null;
  },
  onKeyDown: null,
  scrollable: true
};